<template>
  <div
    class="main-category"
    :class="{ 'main-category--full-width': fullWidth }"
  >
    <div class="main-category__header">
      <span class="main-category__title">{{ data | localeField("name") }}</span>
      <router-link
        v-show="!fullWidth && false"
        :to="{
          name: 'category',
          params: { id: $route.params.id, category_id: data.id }
        }"
        class="main-category__show-more"
      >
        {{ $t("services.showMore") }}
      </router-link>
      <!--      <icon name="service-presentation" />-->
    </div>
    <div class="main-category__body">
      <div class="main-category__childs">
        <router-link
          v-for="(child, i) in data.children"
          :key="i"
          :to="{
            name: 'category',
            params: { id: $route.params.id, category_id: child.id }
          }"
          class="main-category__child"
        >
          {{ child | localeField("name") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainCategoryComponent",
  props: {
    data: Object,
    fullWidth: Boolean
  }
};
</script>

<style lang="scss">
.main-category {
  background: var(--white, #fff);
  border: 1px solid var(--gray-darker, #d5dae5);
  box-sizing: border-box;

  &--full-width &__childs {
    column-count: 3;
    @media (max-width: 700px) {
      column-count: 2;
    }
  }

  &__header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
    padding: 20px 30px;
    border-bottom: 1px solid var(--gray-darker, #d5dae5);
    @media (max-width: 540px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 15px;
    }

    .svg-icon {
      width: 60px;
      height: 60px;
      position: absolute;
      right: 30px;
      top: 50%;
      opacity: 0.1;
      transform: translateY(-50%);
      pointer-events: none;
      @media (max-width: 540px) {
        width: 40px;
        height: 40px;
      }
    }
  }

  &__title {
    color: var(--dark, #262626);
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 28px;
    margin-right: 30px;
    @media (max-width: 540px) {
      font-size: 1rem;
      font-weight: 700;
      line-height: 24px;
    }
  }

  &__show-more {
    color: var(--dark-light, #6d7179);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 18px;
    @media (max-width: 540px) {
      margin-top: 5px;
    }

    &:hover {
      color: var(--main-dark, #005197);
    }
  }

  &__body {
    padding: 30px;
    @media (max-width: 540px) {
      padding: 15px;
    }
  }

  &__childs {
    column-count: 2;
    column-gap: 15px;
    @media (max-width: 480px) {
      column-count: 1;
    }
  }

  &__child {
    color: var(--dark-light, #6d7179);
    font-size: 0.75rem;
    line-height: 18px;
    text-decoration-line: underline;
    display: block;
    margin-bottom: 15px;
    break-inside: avoid-column;

    &:hover {
      color: var(--main, #005197);
    }
  }
}
</style>
